import React, { useEffect, useState } from 'react'
import './DashBoard.css'
import { BarcodeScanner } from '@thewirv/react-barcode-scanner';
import { BarChart } from '@mui/x-charts/BarChart';
import { DashBoardData, RootDashBoardData } from './HomeDataInfo';
import { AxiosInstance } from '../../api/apiInstance';
import { useDispatch, useSelector } from 'react-redux';
import { IBadgeStatus } from '../../interface/IUser';
import { increment } from '../../redux/BadgeStatusSlice';
import { IconButton, Stack } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

function Home() {


  //IBadgeStatus
  const dispatch = useDispatch()
  const badgeInfo: IBadgeStatus = useSelector((state: any) => state.badge)

  const [allData, setAllData] = useState<RootDashBoardData>(DashBoardData)

  async function GetData() {
    try {
      await AxiosInstance({
        // url of the api endpoint (can be changed)
        url: "report-view/DashBoard/",
        method: "GET",
      }).then((res) => {
        // handle success
        const tmpData: RootDashBoardData=  res.data
       
            
        
        setAllData(tmpData);   

      });
    } catch (e) {
      // handle error
      console.error(e);
    }
  }
  useEffect(() => {
    GetData();
  }, []);
  useEffect(() => {
    //if (allData===undefined) return    
    let taskCount = allData?.tasks.filter((dt) => { if (dt.status === 'New') return true; return false; })
      .reduce((taskCount, or) => taskCount + or.countStatus, 0)|| 0;      
    let tmpOrderCount = allData?.orders.filter((dt) => { if (dt.status === 'New') return true; return false; })
      .reduce((tmpOrderCount, or) => tmpOrderCount + or.countStatus, 0) || 0;
    const badgeStatus: IBadgeStatus = { orderCount: tmpOrderCount , taskCount: taskCount};
    dispatch(increment(badgeStatus))
  }, [allData]);


  const seriesNew = {
    data: allData?.tasks?.filter((dt) => {
      if (dt.status === "New") return true; else return false;
    }).map(n => n.countStatus),
    label: 'New',

  };
  const seriesInProgress = {
    data: allData?.tasks?.filter((dt) => {
      if (dt.status === "In Progress") return true; else return false;
    }).map(n => n.countStatus),
    label: 'In Progress',
  };
  const seriesComplete = {
    data: allData?.tasks?.filter((dt) => {
      if (dt.status === "Complete") return true; else return false;
    }).map(n => n.countStatus),
    label: 'Complete',
  };
  const seriesPending = {
    data: allData?.tasks?.filter((dt) => {
      if (dt.status === "Pending") return true; else return false;
    }).map(n => n.countStatus),
    label: 'Pending',
  };

  const seriesOrderNew = {
    data: allData?.orders?.filter((dt) => {
      if (dt.status === "New") return true; else return false;
    }).map(n => n.countStatus),
    label: 'new',

  };
  const seriesOrderInProgress = {
    data: allData?.orders?.filter((dt) => {
      if (dt.status === "In Progress") return true; else return false;
    }).map(n => n.countStatus),
    label: 'In Progress',
  };
  const seriesOrderComplete = {
    data: allData?.orders?.filter((dt) => {
      if (dt.status === "Complete") return true; else return false;
    }).map(n => n.countStatus),
    label: 'Complete',
  };
  const seriesOrderPending = {
    data: allData?.orders?.filter((dt) => {
      if (dt.status === "Pending") return true; else return false;
    }).map(n => n.countStatus),
    label: 'Pending',
  };

  //const [scanData, setScanData] = useState('na')
  return (
    <div className='dashboard'>
      <Stack direction='row'><h2> Tasks</h2>
      <IconButton size="large" onClick={() => GetData()}>
          <RefreshIcon />
        </IconButton>
</Stack>
      
      <BarChart
        //dataset={DashBoardTaskHeader}
        xAxis={[{ scaleType: 'band', data: ['Assembly', 'Assembly Order','Good received', 'Inventory count', 'Warehouse changes'] }]}
        width={700}
        height={230}
        series={
          [
           { ...seriesNew },
           { ...seriesInProgress },
           { ...seriesComplete, },
           { ...seriesPending, },
          ]}
      />
      <h2> Orders</h2>
      <BarChart
        xAxis={[{
          scaleType: 'band', data: ['Picker', 'Packer', 'Shiper', 'QC','Administrator'],

        }]}
        width={700}
        height={230}
        series={[
             { ...seriesOrderNew },
             { ...seriesOrderInProgress },
             { ...seriesOrderComplete },
             { ...seriesOrderPending },
           ]
        }
      />

    </div>
  )

}

export default Home